import {Component, ElementRef, Input, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {AntragSpaeterFortsetzenDialogComponent} from '@wba-ui-module/components/dialogs/antrag-spaeter-fortsetzen-dialog/antrag-spaeter-fortsetzen-dialog.component';
import {AntragsdatenService} from '@wba/services/api/antragsdaten/antragsdaten.service';
import {Observable} from 'rxjs';

@Component({
  selector: 'wba-antrag-spaeter-fortsetzen',
  templateUrl: './antrag-spaeter-fortsetzen.component.html',
  standalone: false
})
export class AntragSpaeterFortsetzenComponent {

  @Input() _id = 'ASF';
  @Input() dataAnalyticsName = '';
  @Input() btnDisabled = false;
  @ViewChild('buttonElement') buttonElement: ElementRef;
  @ViewChild('modalDialog') modalDialog: AntragSpaeterFortsetzenDialogComponent;

  public letzteAenderungAm$: Observable<string> = this.draftService.letzteAenderungAm$;

  constructor(private readonly router: Router,
              private readonly draftService: AntragsdatenService,) {
  }

  clickEvent() {
    this.modalDialog.open(this.buttonElement.nativeElement);
  }

  routeToFMS() {
    return this.router.navigate(['/'], {queryParams: {v: null}, queryParamsHandling: 'merge'});
  }

}
